import { useParams } from "react-router-dom";
import CancelIcon from "../../assets/img/cancel-01.svg";
import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";

const ConfirmMemberRemovalModal = ({ onClose, llData, refreshFunc }) => {
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user } = useContext(AuthContext);
  const { deleteWorkspaceMember } = useContext(LandLordContext);

  const [buttonDisable, setButtonDisable] = useState(false);

  const handleSubmitButton = () => {
    setButtonDisable(true);
    const sendData = {
      user_id: llData?.landlordId?._id,
    };
    deleteWorkspaceMember(sendData)
      .then((res) => {
        toast.success(_t("memberRemovedSuccessfully"));
        refreshFunc();
        onClose();
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileRemovingMember"));
      })
      .finally(() => {
        setButtonDisable(false);
      });
  };
  console.log("AniketShouldBeHere");
  return (
    <div className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal confirmRemovalModalWrapper">
      <div className="popup-content2 popup-content bg-white guarantorDocuments confirmRemovalModal position-relative">
        <div className="d-flex flex-column">
          <div className="d-flex ps-0 gap-4 align-items-center justify-content-between">
            <div>
              <h4>
                {_t("confirmMemberRemovalFromWorkspace")}{" "}
                {user?.workspaceIds?.find(
                  (val) => val?.uuid?.toString() === workspaceId?.toString(),
                )?.name ?? ""}
              </h4>
            </div>
            <div className="cursor-pointer" onClick={onClose}>
              <img
                src={CancelIcon}
                alt="icon"
                className="canceicon topRightIcon"
              />
            </div>
          </div>
          <p className="tenant-doc-text">
            {_t("areYouSureYouWantToRemoveThisMemberFromThisYourWorkspaces")}
          </p>
          <div className="userimg-btn-style d-flex justify-content-center">
            <div
              className="d-flex align-items-center gap-2 box-img-style"
              style={{ width: "fit-content" }}
            >
              <div>
                <img src={UserIcon} alt="img" />
              </div>
              <div>
                <p>
                  {`${llData?.landlordId?.fname_companyName} ${llData?.landlordId?.lname}`}{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center custom-gap-3 buttonWrapperDocument">
          <button
            type="button"
            className="btnNext btnnextpre"
            onClick={onClose}
            disabled={buttonDisable}
          >
            {_t("noGoBack")}
          </button>
          <button
            type="button"
            className="btnNext"
            onClick={handleSubmitButton}
            disabled={buttonDisable}
          >
            {_t("yesRemove")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmMemberRemovalModal;
